export const TABLE_NAME = 'report-templates';
export const MAX_FILE_SIZE = 1024 * 1024 * 10; // 10 МБ
